globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.LibraryBlogConfiguration = (function(superClass) {

  utils.extend(LibraryBlogConfiguration, superClass);

  function LibraryBlogConfiguration($html) {
    this.$html = $html;

    return LibraryBlogConfiguration.__super__.constructor.apply(this, arguments);
  }

  $.extend(LibraryBlogConfiguration.prototype, {
    init: function() {
      return LibraryBlogConfiguration.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data, successMsg) {
      if (data == null) {
        data = {};
      }

      if (data.response) {
        this.close();
        location.reload();
      } else {
        appCustomerSpace.Loader().stop();
      }
    }
  });

  return LibraryBlogConfiguration;

})(appCustomerSpace.Modal);
